<template>
  <header class="create-ticket-header">
    <p class="create-ticket-header__title">{{ props.title }}</p>
    <section class="create-ticket-header__buttons">
      <ButtonText
        class="create-ticket-header__buttons__button"
        :iconLeft="iconXSmall"
        size="extra-small"
        @onClicked="closeModal"
      ></ButtonText>
    </section>
  </header>
</template>
<script lang="ts" setup>
import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import iconXSmall from '@/design-system/assets/icons/Icon-X-Small.svg'

interface EMITS {
  (e: 'closeCreateTicketModal', value: boolean): void
}
const emits = defineEmits<EMITS>()

const props = defineProps<{
  title: string
}>()

function closeModal() {
  emits('closeCreateTicketModal', false)
}
</script>
<style scoped lang="scss">
@use '@/design-system/design-tokens/variables.scss';
@use '@/design-system/design-tokens/font-mixins.scss';
@use '@/design-system/design-tokens/mixins.scss';

.create-ticket-header {
  display: flex;
  height: 32px;
  margin-bottom: 16px;
  &__buttons {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 4px;
    margin-left: auto;
    &__button {
      height: 24px;
      min-width: 24px;
      padding: 0;
      width: 24px;
      &:nth-child(3) {
        margin-left: 8px;
      }
    }
  }
  &__title {
    color: variables.$color-greyscale-content;
    margin: 0;
    margin-right: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: max-content;
    @include font-mixins.desktop-bold-h4;
  }
}
</style>
